<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-button type="primary" @click="getBillRecord()">刷新页面</el-button>
      <el-button type="success" @click="exportRecord()">导出Excel</el-button>

      <el-table v-loading="loading" :data="tableData">
        <el-table-column label="流水号" align="center" width="150px" prop="id"></el-table-column>
        <el-table-column label="分润主体id" align="center" width="150px" prop="accountId"></el-table-column>
        <el-table-column label="分润主体名称" align="center" width="150px" prop="accountName"></el-table-column>
        <el-table-column label="商家ID" align="center" width="150px" prop="popId"></el-table-column>
        <!-- <el-table-column label="商家名称" align="center" width="150px" prop="popName"></el-table-column> -->
        <el-table-column label="订单号" align="center" width="100px" prop="orderId"></el-table-column>
        <el-table-column label="订单oiid" align="center" width="100px" prop="orderItemId"></el-table-column>
        <el-table-column label="下单日期" align="center" width="100px" prop="orderCreateTimeStr"></el-table-column>
        <el-table-column label="收款日期" align="center" width="100px" prop="orderReceiptTimeStr"></el-table-column>
        <el-table-column label="城市" align="center" width="100px" prop="cityName"></el-table-column>
        <el-table-column label="Sku id" align="center" width="100px" prop="skuId"></el-table-column>
        <el-table-column label="Ssu id" align="center" width="100px" prop="ssuId"></el-table-column>
        <el-table-column label="ssu名称" align="center" width="100px" prop="ssuName"></el-table-column>
        <el-table-column label="一级分类" align="center" width="100px" prop="pmsClass1Name"></el-table-column>
        <el-table-column label="二级分类" align="center" width="100px" prop="pmsClass2Name"></el-table-column>
        <el-table-column label="三级分类" align="center" width="100px" prop="pmsClass3Name"></el-table-column>
        <el-table-column label="门店ID" align="center" width="100px" prop="companyId"></el-table-column>
        <el-table-column label="结算状态" align="center" width="100px" prop="settleStatusStr"></el-table-column>
        <el-table-column label="代付品牌方服务费" align="center" width="100px" prop="serviceAmount"></el-table-column>
        <el-table-column label="美菜服务费扣点" align="center" width="100px" prop="platformPointRate"></el-table-column>
        <el-table-column label="美菜服务费金额" align="center" width="100px" prop="platformPoint"></el-table-column>
      </el-table>
      <div class="footer pager">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          v-model:current-page="formData.pageNumber"
          v-model:page-size="formData.pageSize"
          :page-sizes="[20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          v-model:total="total"
          background
        ></el-pagination>
      </div>
    </basic-container>
  </div>
</template>
<script>
import basicContainer from "@vue-materials/basic-container";
export default {
  components: {
    basicContainer,
  },

  data() {
    return {
      tableData: [],
      formData: {
        billId: "",
        subjectId: "",
        pageNumber: 1,
        pageSize: 20,
        billRecordType: 1,
      },
      loading: false,
    };
  },
  created() {

  },

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      try {
        console.log(billId);
        console.log(subjectId);
        vm.formData.billId = billId;
        vm.formData.subjectId = subjectId;
        vm.getBillRecord();
      } catch (error) {
        console.log(error);
        next();
      }
    })
  },

  beforeRouteLeave(to, from, next) {
    this.$destroy();
    next();
  },

  methods: {
    initData (id, subjectId) {
      this.formData.billId = id;
      this.formData.subjectId = subjectId;
      this.getBillRecord();
    },

    async getBillRecord() {
      this.loading = true;
      try {
        this.loading = true;
        const {ret, data} = await _api.splitAcc.getBillRecord(this.formData);
        if (ret && data) {
          this.tableData = data.data || [];
          this.total = data.total;
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    async exportRecord() {
      this.loading = true;

      try {
        const {
          ret,
          data
        } = await _api.splitAcc.billRecordExport(this.formData);
        if (ret && data) {
          const downloadUrl = data;
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = "下单流水明细.xlsx";
          link.target = "_blank"; //在新标签页中下载
          link.click();
        }
      } catch (error) {
        console.error("下载文件出错", error);
      }

      this.loading = false;

      //exportFile(`${getBaseUrl()}/dmall-manage/dmallmanage/order/export`,this.formData,'订单数据.xlsx')
    },

    handleCurrentChange(val) {
      this.formData.pageNumber = val;
      this.getBillRecord();
    },
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.formData.pageNumber = 1;
      this.getBillRecord();
    },
  },
};
</script>